export const urlPayments_assignorFees = 'payment/assignor-fees';
export const urlPayments_allTransactions = 'payment/all-transactions';
export const urlPayments_paymentDetails = 'payment/details';